import React, {useEffect, useState} from 'react'
import {get} from "../../../../Model/Network/Config/Axios";
import {handleError} from "../../../Common/fToast/ToastCallback";
import {SidePane} from '../../../Common/fSidePane/RightPane'
import {Spinner} from "../../../Common/fLoader";
import Invoice from "./India";


function ViewDebitNote(props) {
	let [loading,setLoading] = useState(true)
	const [details, setDetails] = useState({});
	const [creditId,setCreditId] = useState(undefined);

	useEffect(() => {
		fetchInvoice(props.id)
	}, [props.id,props.creditId]);

	const fetchInvoice = (ID)=>{
		get(`vendor/vendor/debitNotes/${ID}/details`,(e,r)=>{
			if(r){
				setDetails(r);
				setCreditId(r.creditNoteId)
				setLoading(false);

			}else if(e){
				handleError(e)
			}
		})
	}

	if(loading){
		return  <SidePane column={<Spinner/>} button={false} onClose={() => props.onClose(false)}>
			<Spinner/>
		</SidePane>
	}

	return  (
		<Invoice  details={details} onReload={()=>{fetchInvoice(props.id)}} init={props.init} onClose={props.onClose} id={props.creditId?props.creditId:creditId}/>
	)	
	
}

export  {
	ViewDebitNote
}
